// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YH4U","newExpiryDate":"styles_newExpiryDate__1wLch","footer":"styles_footer__3fkwi"};